import React from 'react';
import Modal from 'react-modal';
import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';
import Row from '../../tag/Row';
import modal from '../../../definitions/Modal';

const notificationModal = modal({ content: { width: '500px' } });

const PasswordRenewalModal = (props) => {
  let { hideModal, submit } = props;
  return (
    <Modal
      ariaHideApp={false}
      {...props}
      style={{
        overlay: { ...notificationModal.overlay },
        content: { ...notificationModal.content, textAlign: 'left' },
      }}
    >
      <Row>
        <h4 className="ot-modal__title">
          Lähetetäänkö pyyntö syövänhoidon verkkopoliklinikan salasanan
          uusimiseen?
        </h4>
      </Row>
      <Row>
        <p>
          Voit pyytää uutta salasanaa painamalla Lähetä-painiketta. Tämän
          jälkeen linkki salasanan uusimiseen lähetetään sähköpostiisi.
        </p>
        <br />
      </Row>
      <Row>
        <OTButtonGroup type="big" fullWidth={true}>
          <OTButton key="cancel" onClick={hideModal}>
            Peruuta
          </OTButton>
          <OTButton key="submit" onClick={submit}>
            Lähetä
          </OTButton>
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default PasswordRenewalModal;
